import React from 'react';
import { CacheApiContext, CacheApiContextType, ServicesContext } from '~/services';
import { ReferralSelectOption } from '.';

interface PlanCodesType {
    id: number;
    system_id: number;
    name: string;
}

export function usePlanCodesList(): ReferralSelectOption[] {
    const services = React.useContext(ServicesContext);
    const { getCachedValue } = React.useContext(CacheApiContext) as CacheApiContextType;
    const [planCodesList, setPlanCodesList] = React.useState([]);

    React.useEffect(() => {
        (async () => {
            const planCodeResult = await getCachedValue('planCodes', async () => {
                const result = await services.api.call({
                    method: 'get',
                    url: `/api/core-app-hub-tags?items_per_page=1000000`,
                });
                return result.data['hydra:member']
                    .sort((a: PlanCodesType, b: PlanCodesType) => a.name.localeCompare(b.name))
                    .map((x: PlanCodesType) => ({
                        value: x.system_id,
                        label: x.name,
                    }));
            });
            setPlanCodesList(planCodeResult);
        })();
    }, [services, getCachedValue]);

    return planCodesList;
}
